import type { InitialCarePlan } from '#src/models/care-plans/InitialCarePlan.ts'
import {
  CARE_PLAN_INITIAL_V8_HTML,
  CARE_PLAN_QR_TEMPLATES,
  CARE_PLAN_SEMI_ANNUAL_V8_HTML,
  type CarePlanQuestionnaireTemplates,
} from '#src/models/care-plans/templates/index.ts'

export interface CarePlanCreateDefaults {
  type: keyof typeof InitialCarePlan.TYPES
  title: string
  description: string
  questionnaireTemplates?: CarePlanQuestionnaireTemplates
}

export function getCarePlanCreateDefaults(
  type: keyof typeof InitialCarePlan.TYPES
): CarePlanCreateDefaults {
  switch (type) {
    case 'INITIAL':
      return {
        type,
        title: 'Initial Care Plan',
        description: CARE_PLAN_INITIAL_V8_HTML.trim(),
        questionnaireTemplates: CARE_PLAN_QR_TEMPLATES.v8,
      }
    case 'SEMI_ANNUAL':
      return {
        type,
        title: 'Semi-Annual Care Plan',
        description: CARE_PLAN_SEMI_ANNUAL_V8_HTML,
        questionnaireTemplates: CARE_PLAN_QR_TEMPLATES.v8,
      }
    case 'CHANGE_OF_CARE':
      return {
        type,
        title: 'Change of Condition Care Plan',
        description: '',
      }
  }
}
